import React from "react";
import circleLogo from "../assets/circleLogo.png";
import { useIsTyping } from "../utils/typingGate";

interface TypingIndicatorProps {}

const TypingIndicator: React.FC<TypingIndicatorProps> = () => {
  const isTyping = useIsTyping();

  if (!isTyping) {
    return null;
  }
  return (
    <div className="flex justify-start mb-2 sm:mb-3 lg:mb-4">
      <div className="flex items-start gap-2 sm:gap-3">
        <img
          src={circleLogo}
          alt="Bot"
          className="w-5 h-5 sm:w-6 sm:h-6 rounded-full flex-shrink-0 mt-3 sm:mt-4"
        />
        <div className="max-w-[85%] sm:max-w-[80%] md:max-w-[75%] lg:max-w-[70%] rounded-3xl p-3 sm:p-4 bg-gray-100 text-gray-800">
          <div className="flex items-center justify-center space-x-1">
            <div className="flex space-x-1">
              <div
                className="w-2 h-2 bg-gray-400 rounded-full"
                style={{
                  animation: "typing-bounce 1.4s infinite ease-in-out",
                  animationDelay: "0ms",
                }}
              ></div>
              <div
                className="w-2 h-2 bg-gray-400 rounded-full"
                style={{
                  animation: "typing-bounce 1.4s infinite ease-in-out",
                  animationDelay: "200ms",
                }}
              ></div>
              <div
                className="w-2 h-2 bg-gray-400 rounded-full"
                style={{
                  animation: "typing-bounce 1.4s infinite ease-in-out",
                  animationDelay: "400ms",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
